import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { getAccessToken } from 'utils';
import { dashboardRouteConstants, authRouteConstants } from 'constants/routeConstants';

/**
 * NotFoundRedirect
 * Shown when a user navigates to a route that doesn't exist in the app.
 * - If logged in  → redirect to /dashboard with a warning toast.
 * - If logged out → redirect to the landing page.
 */
const NotFoundRedirect = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const token = getAccessToken();
        if (token) {
            enqueueSnackbar('You are not authorised to visit this page.', {
                variant: 'warning',
                autoHideDuration: 3000,
            });
            navigate(dashboardRouteConstants.HOME, { replace: true });
        } else {
            navigate(authRouteConstants.HOME, { replace: true });
        }
    }, []);

    return null;
};

export default NotFoundRedirect;
